var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("首页")]),_c('p',{staticClass:"lead"})])])
}]

export { render, staticRenderFns }